module.exports = __webpack_public_path__ + "static/media/oakview-early-years-services.a0895d6b.png";